import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { useEffect } from "react";
import PageWrapper from "@/components/layout/PageWrapper";
import { pushDataLayerEvent, sendGtagEvent } from "@/utils/tracking";

export default function ThankYou() {
  const { t } = useTranslation();

  useEffect(() => {
    pushDataLayerEvent("thank_you_page_view", {
      page_path: window.location.pathname,
    });

    // Google Ads conversion tracking
    sendGtagEvent("conversion", {
      send_to: "AW-17006649430/VXLQCNOnl6gcENbAs60_",
      value: 1.0,
      currency: "SAR",
    });
  }, []);

  return (
    <PageWrapper>
      {/* SEO */}
      <title>{t("meta.thankYouTitle")}</title>
      <meta name="description" content={t("meta.thankYouDesc")} />

      <section className="relative w-full px-4 md:px-8 lg:px-12 pt-28 md:pt-36 pb-16 md:pb-24 overflow-hidden">
        <motion.span
          className="pointer-events-none absolute top-20 right-10 h-40 w-40 rounded-full bg-brand/10 blur-3xl"
          animate={{ x: [0, -16, 0], y: [0, 18, 0] }}
          transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.span
          className="pointer-events-none absolute bottom-10 left-8 h-48 w-48 rounded-full bg-amber-200/30 blur-3xl"
          animate={{ x: [0, 18, 0], y: [0, -14, 0] }}
          transition={{ duration: 11, repeat: Infinity, ease: "easeInOut" }}
        />
        <div className="mx-auto max-w-3xl min-h-[56vh] flex items-center justify-center">
          <motion.div
            className="w-full text-center rounded-3xl border border-stone-200 bg-white px-6 py-10 md:px-12 md:py-14 shadow-[0_10px_40px_rgba(0,0,0,0.06)]"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
          >
            <motion.span
              className="w-20 h-20 md:w-24 md:h-24 flex items-center justify-center bg-brand/10 text-brand rounded-full mx-auto mb-8"
              animate={{ scale: [1, 1.08, 1] }}
              transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
            >
              <i className="ri-check-line text-4xl md:text-5xl" />
            </motion.span>
            <h1 className="text-4xl md:text-6xl font-bold text-stone-900 mb-6 leading-tight">
              {t("contact.successMessage")}
            </h1>
            <p className="text-lg md:text-xl text-stone-600 mb-10 leading-relaxed">
              {t("contact.successDesc")}
            </p>
            <a
              href="/"
              className="inline-flex items-center gap-2 bg-brand text-white font-semibold px-8 py-4 rounded-full hover:bg-brand-dark transition-colors whitespace-nowrap cursor-pointer"
            >
              {t("nav.home")}
              <span className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full">
                <i className="ri-home-line text-sm" />
              </span>
            </a>
          </motion.div>
        </div>
      </section>
    </PageWrapper>
  );
}